<div class="dashboard-navigator-item" 
    routerLinkActive="dashboard-navigator-item-active"
    [routerLinkActiveOptions]="{ exact: true }">
    <a [routerLink]="link">
        <span><img [src]="img" ></span>
        <div >{{ title }}</div>
    </a>
</div>